import React from 'react';
import FormField from './FormField';

/**
 * @typedef IProps
 * @property {string} value
 * @property {React.Dispatch<string>} setValue
 *
 * @param {IProps} props
 */
function InputName({ value, setValue }) {
  return (
    <FormField
      type="text"
      label="ชื่อ-สกุล"
      placeholder="ชื่อ สกุล"
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default InputName;
